module.exports = __webpack_public_path__ + "static/Logo_amorphic-a26e1aac81e30845437875bd6d6422ae.svg";